import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Typography } from '@mui/material';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../../i18n/constants/keys';
import { LoadingOverlay } from '../../../../../../ui/components/Common/DataTable/Conmponents/LoadingOverlay';
import { CandidateDetails } from './Components/CandiateDetais';
import { EmptyState, ErrorFallback } from './Components/EmptyState';
import { UserSelection } from './Components/UserSelection';
import { useOffer } from './Hooks/UseOffer';

export interface IOffer {
  jobOpeningId: string;
}

export const Offer: React.FC<IOffer> = ({ jobOpeningId }) => {
  const { t } = useTranslation(NS.adminPages);
  const SI = ADMIN_PAGES_KEYS.jobOpenings.smartInterviews;
  const {
    candidates,
    isLoading,
    error,
    selectedCandidate,
    selectedCandidateId,
    getStatusColor,
    getUserInitials,
    totalCandidates,
    setSelectedCandidateId,
    limit,
    page,
    setPage,
    setCandidates,
    updateCandidateOfferStatus,
    isUpdatingStatus,
    addCandidatesFromPreviousRound,
  } = useOffer({
    jobOpeningId,
  });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'action.hover',
        p: 2,
        gap: 2,
        borderRadius: 3,
      }}
    >
      {isLoading ? (
        <LoadingOverlay />
      ) : error ? (
        <ErrorFallback error={error} />
      ) : candidates.length === 0 ? (
        <EmptyState
          jobOpeningId={jobOpeningId}
          addCandidatesFromPreviousRound={addCandidatesFromPreviousRound}
        />
      ) : (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
          {/* Avatars Section */}
          <UserSelection
            candidates={candidates}
            selectedCandidateId={selectedCandidateId}
            setSelectedCandidateId={setSelectedCandidateId}
            totalCandidates={totalCandidates}
            getStatusColor={getStatusColor}
            getUserInitials={getUserInitials}
            selectedCandidate={selectedCandidate}
            jobOpeningId={jobOpeningId}
            setCandidates={setCandidates}
            addCandidatesFromPreviousRound={addCandidatesFromPreviousRound}
            limit={limit}
            page={page}
            onPreviousPageChange={setPage}
            onNextPageChange={setPage}
          />
          {/* Details Section */}
          {selectedCandidate ? (
            <CandidateDetails
              selectedCandidate={selectedCandidate}
              isUpdatingStatus={isUpdatingStatus}
              updateCandidateOfferStatus={updateCandidateOfferStatus}
            />
          ) : (
            <Paper
              elevation={2}
              sx={{
                borderRadius: 4,
                p: 4,
                textAlign: 'center',
                border: 1,
                borderColor: 'divider',
              }}
            >
              <Typography variant="body1" color="text.secondary">
                {t(SI.offer.selectCandidate)}
              </Typography>
            </Paper>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Offer;
